import styled from 'styled-components'

export const FormWrapper = styled.div`
	margin-top: 4px;
	margin-left: 52px;
`
